import { apiClient } from './authService';

// Client dossier entries: Soin / Diagnostic visage / Poids / Cheveux.
// One backend table (customers/records/) keyed by `category`.
const clientRecordService = {
  // List a client's records, optionally filtered by category.
  getRecords: async ({ customer, category } = {}) => {
    try {
      const params = new URLSearchParams();
      if (customer) params.set('customer', customer);
      if (category) params.set('category', category);
      params.set('page_size', 1000);
      const res = await apiClient.get(`customers/records/?${params.toString()}`);
      const d = res.data;
      return Array.isArray(d) ? d : (d.results || []);
    } catch (error) {
      throw error.response?.data || { message: 'Error fetching client records' };
    }
  },

  // Create a record. `payload` may be a FormData (when an image is attached)
  // or a plain object (JSON). Axios sets the right Content-Type for FormData.
  createRecord: async (payload) => {
    try {
      const res = await apiClient.post('customers/records/', payload, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return res.data;
    } catch (error) {
      throw error.response?.data || { message: 'Error creating record' };
    }
  },

  // Create (no id) or update (id) a dossier record. `payload` is a FormData
  // (so it can carry an image). apiClient defaults to JSON, so we MUST override
  // the Content-Type to multipart/form-data — otherwise the file is sent without
  // a boundary and the backend can't parse it (upload fails with "Échec").
  saveRecord: async (payload, existingId) => {
    try {
      const cfg = { headers: { 'Content-Type': 'multipart/form-data' } };
      const res = existingId
        ? await apiClient.patch(`customers/records/${existingId}/`, payload, cfg)
        : await apiClient.post('customers/records/', payload, cfg);
      return res.data;
    } catch (error) {
      throw error.response?.data || { message: 'Error saving record' };
    }
  },

  deleteRecord: async (id) => {
    try {
      await apiClient.delete(`customers/records/${id}/`);
    } catch (error) {
      throw error.response?.data || { message: 'Error deleting record' };
    }
  },
};

export default clientRecordService;
